// import ModeSwitcher from "./ModeSwitcher";
import OutboundLinkIcon from "./OutboundLinkIcon";
import { useTranslation } from "react-i18next";

function Announcement() {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const href = currentLanguage === 'ja' ? 'https://myna.go.jp/html/hokenshoriyou_top.html' : 'https://www.digital.go.jp/en/policies/mynumber_contact';
  return (
    <div
      id="ab-full-width-with-dismiss-button-on-blue-bg"
      className="bg-modern-accent"
    >
      <div className="max-w-[85rem] px-4 py-2 sm:px-6 lg:px-8 mx-auto">
        <div className="flex items-center justify-center">
          <p className="text-white">
            {t('マイナンバーカードの保険証利用登録がお済でない方は、今すぐご登録を！')}{" "}
            <a
              className="decoration-2 underline font-medium hover:text-white/80"
              href={href}
              target="myna.go.jp"
            >
              {t('申し込み方法はこちら')}{" "}
            </a>
            <OutboundLinkIcon />
          </p>

          <div className="hidden ps-3 ms-auto">
            <button
              type="button"
              className="inline-flex rounded-lg p-1.5 text-white/80 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-blue-600 focus:ring-white"
              data-hs-remove-element="#ab-full-width-with-dismiss-button-on-blue-bg"
            >
              <span className="sr-only">{t('表示しない')}</span>
              <svg
                className="flex-shrink-0 size-4"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Announcement;
